import React, { useState } from "react";
import { Mail, Twitter } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://formspree.io/f/xrejndqv", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          message: form.message,
        }),
      });
      if (response.ok) {
        setSent(true);
      } else {
        alert("Something went wrong. Please try again.");
      }
    } catch (_) {
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="pt-5 pb-20">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">

        <div className="mb-12 mt-6">
          <span className="font-mono text-xs text-yellow-400 uppercase tracking-[0.3em]">/contact</span>
          <h1 className="font-display font-bold text-4xl md:text-5xl text-white tracking-tighter mt-2">
            Contact Us
          </h1>
          <p className="text-zinc-400 mt-3 max-w-xl">
            Have a tip, story idea, or partnership inquiry? We would love to hear from you.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">

          <div className="bg-[#0a0a0b] border border-white/10 p-8">
            <h2 className="font-display font-bold text-xl text-white mb-6">Send a Message</h2>

            {sent ? (
              <div className="text-center py-12">
                <div className="w-12 h-12 bg-yellow-400 flex items-center justify-center mx-auto mb-4">
                  <Mail className="w-6 h-6 text-black" />
                </div>
                <p className="font-display font-bold text-white text-lg">Message sent!</p>
                <p className="text-zinc-400 text-sm mt-2">We will get back to you within 24 hours.</p>
                <button
                  onClick={() => { setSent(false); setForm({ name: "", email: "", message: "" }); }}
                  className="mt-6 text-xs font-mono uppercase tracking-wide text-yellow-400 hover:underline"
                >
                  Send another message
                </button>
              </div>
            ) : (
              <div className="space-y-5">
                <div>
                  <label className="text-xs font-mono uppercase tracking-widest text-zinc-500 block mb-2">
                    Your Name
                  </label>
                  <input
                    type="text"
                    value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                    placeholder="John Doe"
                    className="w-full bg-zinc-900 border border-white/10 text-white px-4 py-3 text-sm focus:outline-none focus:border-yellow-400 transition placeholder:text-zinc-600"
                  />
                </div>
                <div>
                  <label className="text-xs font-mono uppercase tracking-widest text-zinc-500 block mb-2">
                    Email Address
                  </label>
                  <input
                    type="email"
                    value={form.email}
                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                    placeholder="john@example.com"
                    className="w-full bg-zinc-900 border border-white/10 text-white px-4 py-3 text-sm focus:outline-none focus:border-yellow-400 transition placeholder:text-zinc-600"
                  />
                </div>
                <div>
                  <label className="text-xs font-mono uppercase tracking-widest text-zinc-500 block mb-2">
                    Message
                  </label>
                  <textarea
                    rows={5}
                    value={form.message}
                    onChange={(e) => setForm({ ...form, message: e.target.value })}
                    placeholder="Your message..."
                    className="w-full bg-zinc-900 border border-white/10 text-white px-4 py-3 text-sm focus:outline-none focus:border-yellow-400 transition placeholder:text-zinc-600 resize-none"
                  />
                </div>
                <button
                  onClick={handleSubmit}
                  className="w-full bg-yellow-400 text-black font-bold uppercase tracking-wide py-3 hover:bg-yellow-500 transition"
                >
                  Send Message
                </button>
              </div>
            )}
          </div>

          <div className="space-y-6">
            <div className="bg-[#0a0a0b] border border-white/10 p-6">
              <div className="flex items-center gap-4 mb-3">
                <div className="w-10 h-10 bg-yellow-400/10 border border-yellow-400/20 flex items-center justify-center">
                  <Mail className="w-5 h-5 text-yellow-400" />
                </div>
                <div>
                  <div className="text-xs font-mono uppercase tracking-widest text-zinc-500">Email</div>
                  <div className="text-white font-medium mt-1">contact@mediacrypto.ai</div>
                </div>
              </div>
              <p className="text-zinc-400 text-sm">For editorial inquiries, tips, and general questions.</p>
            </div>

            <div className="bg-[#0a0a0b] border border-white/10 p-6">
              <div className="flex items-center gap-4 mb-3">
                <div className="w-10 h-10 bg-yellow-400/10 border border-yellow-400/20 flex items-center justify-center">
                  <Twitter className="w-5 h-5 text-yellow-400" />
                </div>
                <div>
                  <div className="text-xs font-mono uppercase tracking-widest text-zinc-500">Twitter / X</div>
                  <div className="text-white font-medium mt-1">@MediaCryptoAI</div>
                </div>
              </div>
              <p className="text-zinc-400 text-sm">Follow us for live crypto news and market updates.</p>
            </div>

            <div className="bg-[#0a0a0b] border border-yellow-400/20 p-6">
              <h3 className="font-display font-bold text-white mb-2">Editorial Standards</h3>
              <p className="text-zinc-400 text-sm leading-relaxed">
                MediaCrypto is committed to accurate, unbiased crypto journalism. We do not accept payment for editorial coverage. All articles represent the independent views of our editorial team.
              </p>
            </div>

            <div className="bg-[#0a0a0b] border border-white/10 p-6">
              <h3 className="font-display font-bold text-white mb-2">Response Time</h3>
              <p className="text-zinc-400 text-sm leading-relaxed">
                We aim to respond to all inquiries within 24-48 hours. For urgent news tips, please mention it in the subject line.
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}